import React, { useState } from 'react';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import SubPagesLayout from 'layouts/SubPagesLayout';
import TabsListing from 'components/common/tabs/TabsListing';
import {
  entertainmentData,
  fashionShowData,
  promotionPartiesData,
  awardData,
  musicalNightData,
  adultPartyData,
  tradeShowData,
  thematicPartiesData,
  qawaliNightData,
  musicalCardData,
  fashionCardData,
  aperciationCardData,
  musicalNCardData,
  partyCardData,
  tradeCardData,
  themeCardData,
  qawaliCardData,
  promotionalCardData,
  entertainmentDetailPage
} from 'helpers/portfolioHelper';
import CommonDetail from 'components/common/CommonDetail';

const EntertainmentPage = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'ENTERTAINMENT EVENTS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('Musical Events');

  let [tabList] = useState([
    {
      id: 1,
      name: 'Musical Events',
      component: (
        <TabsListing
          list={entertainmentData.slice(1, 6)}
          cardData={musicalCardData}
        />
      ),
    },
    {
      id: 2,
      name: 'Fashion Shows',
      component: (
        <TabsListing
          list={fashionShowData.slice(1, 6)}
          cardData={fashionCardData}
        />
      ),
    },
    {
      id: 3,
      name: 'Promotional Parties',
      component: (
        <TabsListing
          list={promotionPartiesData.slice(1, 6)}
          cardData={promotionalCardData}
        />
      ),
    },
    {
      id: 4,
      name: 'Employee Apericiation',
      component: (
        <TabsListing list={awardData.slice(1, 6)} cardData={aperciationCardData} />
      ),
    },
    {
      id: 5,
      name: 'Musical Night',
      component: (
        <TabsListing
          list={musicalNightData.slice(1, 6)}
          cardData={musicalNCardData}
        />
      ),
    },
    {
      id: 6,
      name: 'Adult Parties',
      component: (
        <TabsListing
          list={adultPartyData.slice(1, 6)}
          cardData={partyCardData}
        />
      ),
    },
    {
      id: 7,
      name: 'Trade Show',
      component: (
        <TabsListing
          list={tradeShowData.slice(1, 6)}
          cardData={tradeCardData}
        />
      ),
    },
    {
      id: 8,
      name: 'Thematic Parties',
      component: (
        <TabsListing
          list={thematicPartiesData.slice(1, 6)}
          cardData={themeCardData}
        />
      ),
    },
    {
      id: 9,
      name: 'Qawali Night',
      component: (
        <TabsListing
          list={qawaliNightData.slice(1, 6)}
          cardData={qawaliCardData}
        />
      ),
    },
  ]);
  return (
    <>
      <section className='DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
        <div className='max-w-7xl mx-auto'>
          <CommonDetail data={entertainmentDetailPage}/>
          <div>
            <TitleSection titleDetail={titleDetail} />
            <CommonTab
              tabList={tabList}
              setCurrentTab={setCurrentTab}
              currentTab={currentTab}
              maxWidth='max-w-xl'
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SubPagesLayout({ route: 'what we do/entertainment event' })(
  EntertainmentPage
);
